<adapt-activity-section-collapsible [section]="section"
                                    [count]="displayedCount"
                                    [totalCount]="activityGroup.totalCount"
                                    [countTooltip]="countTooltip"
                                    [fallbackText]="fallbackText"
                                    [isLoading]="isLoading"
                                    [error]="error">
    <div class="d-flex flex-row flex-wrap gap-3 dashboard-meetings-wrapper">
        <adapt-universal-dashboard-element *ngIf="ongoingMeetings && ongoingMeetings.length > 0"
                                           name="In progress"
                                           [background]="false"
                                           [nested]="true">
            <div class="dashboard-meetings">
                <div *ngFor="let group of ongoingMeetings">
                    <adapt-link-team-meetings-page *adaptIfAlto="false"
                                                   [team]="group.team"
                                                   class="d-block mb-1"></adapt-link-team-meetings-page>
                    <div class="d-flex flex-column gap-3">
                        <adapt-meeting-dashboard-card *ngFor="let meeting of group.meetings"
                                                      [meeting]="meeting"
                                                      [showTeamName]="false"
                                                      [compact]="false"></adapt-meeting-dashboard-card>
                    </div>
                </div>
            </div>
        </adapt-universal-dashboard-element>

        <adapt-universal-dashboard-element *ngIf="upcomingMeetings && upcomingMeetings.length > 0"
                                           name="Upcoming"
                                           [background]="false"
                                           [nested]="true">
            <div class="dashboard-meetings">
                <div *ngFor="let group of upcomingMeetings">
                    <adapt-link-team-meetings-page *adaptIfAlto="false"
                                                   [team]="group.team"
                                                   class="d-block mb-1"></adapt-link-team-meetings-page>
                    <div class="d-flex flex-column gap-3">
                        <adapt-meeting-dashboard-card *ngFor="let meeting of group.meetings"
                                                      [meeting]="meeting"
                                                      [showTeamName]="false"
                                                      [compact]="false"></adapt-meeting-dashboard-card>
                    </div>
                </div>
            </div>
        </adapt-universal-dashboard-element>

        <adapt-universal-dashboard-element *ngIf="upcomingMeetingsPastScheduledDate && upcomingMeetingsPastScheduledDate.length > 0"
                                           name="Meetings past the scheduled date"
                                           [background]="false"
                                           [nested]="true">
            <div class="dashboard-meetings">
                <div *ngFor="let group of upcomingMeetingsPastScheduledDate">
                    <adapt-link-team-meetings-page *adaptIfAlto="false"
                                                   [team]="group.team"
                                                   class="d-block mb-1"></adapt-link-team-meetings-page>
                    <div class="d-flex flex-column gap-3">
                        <adapt-meeting-dashboard-card *ngFor="let meeting of group.meetings"
                                                      [meeting]="meeting"
                                                      [showTeamName]="false"
                                                      [compact]="false"></adapt-meeting-dashboard-card>
                    </div>
                </div>
            </div>
        </adapt-universal-dashboard-element>
    </div>
</adapt-activity-section-collapsible>
